import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { formatReadSettingsAdapts, FormatReadSettingsAdapter } from './format-read-settings.adapter';
import { BinaryFormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/binary-format-read-settings';
import {
    convertCompressionSettingsToResource,
    convertCompressionSettingsToModel
} from '../compression-read-settings/compression-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BinaryFormatReadSettings),
    asynchronous: true,
    adapts: {
        ...formatReadSettingsAdapts
    }
})
export class BinaryFormatReadSettingsAdapter extends FormatReadSettingsAdapter<
    BinaryFormatReadSettings,
    Model.FormatReadSettings
> {
    protected override async _toResource(model: BinaryFormatReadSettings): Promise<Model.FormatReadSettings> {
        const result: Model.FormatReadSettings = FormatReadSettingsAdapter.getCommonReadSettingsProperties(
            Metamodel.modelFor(BinaryFormatReadSettings).name
        );

        await convertCompressionSettingsToResource(model.compressionProperties, result, this.context);

        return result;
    }

    protected override async _toModel(
        resource: Model.FormatReadSettings,
        copySource: CopySource
    ): Promise<BinaryFormatReadSettings> {
        const result = FormatReadSettingsAdapter.createReadSettingsWithCommonProperties(
            BinaryFormatReadSettings.MODEL,
            copySource
        ) as BinaryFormatReadSettings;

        await convertCompressionSettingsToModel(resource.compressionProperties, result, this.context);

        return result;
    }
}
